export function isVideo(url?: string | Blob): boolean {
  if (!url) return false;

  return url instanceof Blob ? url.type.startsWith('video/') : url.endsWith('.mp4');
}
